<template>
  <div>
    <b-button-group class="float-sm-left" size="sm">
      <a class="float-sm-left" href="https://github.com/CHIMEFRB/frb-web/blob/master/src/components/calibration.vue" target="_blank" style="color:black">
        <b-icon icon="github" aria-hidden="true" font-scale="1.0"></b-icon>
      </a>
      <b-button v-b-modal.intensity-calibration-modal>Rerun Fluence/Flux</b-button>
      <b-button variant="info" @click="monitorJob('fluence-frb-web-')">Monitor Job</b-button>
    </b-button-group>
    <b-button variant="dark" size="sm" @click="unsaveParameters('intensity-calibration')">UnSave Results</b-button>
    <b-button variant="success" size="sm" @click="saveParameters('intensity-calibration')">Save Results</b-button>
    <b-button variant="danger" size="sm" @click="flagParameters('intensity-calibration')">Flag for Pipeline Expert</b-button>
    <b-button class="float-sm-right" variant="warning" size="sm" @click="badParameters('intensity-calibration')">Bad Data</b-button>
    <p v-if="rerunintensitycalibration === true" stype="color: green">
        Flux/Fluence job was successfully deployed for this event.
    </p>
    <div v-for="(round, index) in fluenceItems" :key="index" style="margin-top: 50px;">
      <h4> Last Processed on: {{ round['processedAt'] }}</h4>
      <b-row><!--v-if="round['fitData'] != 0">-->
        <b-row>
          <b-col md="6">
            <b-img-lazy fluid width=600 height=400 v-bind:src="`https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=${round['calibration_diagnostic']}`" alt="Failed. Rerun the pipeline before flagging." ></b-img-lazy>
          </b-col>
          <b-col md="3">
            <b-img-lazy fluid width=1000 height=1000 v-bind:src="`https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=${round['fluence_diagnostic']}`" alt="Failed. Rerun the pipeline before flagging."></b-img-lazy>
          </b-col>
          <b-col md="3" style="margin-top: 90px">
            <b-row style="margin-bottom: 15px">
              <b>Flux/Fluence Results:</b>
            </b-row>
            <table border="0">
              <tr align="left">
                <td> Peak Flux (Jy): </td>
                <td> {{ round['fitData']['sub_burst_flux'] }} +/- {{ round['fitData']['sub_burst_flux_error'] }}</td>
              </tr>
              <tr align="left">
                <td> Fluence (Jy ms): </td>
                <td> {{ round['fitData']['sub_burst_fluence'] }} +/- {{ round['fitData']['sub_burst_fluence_error'] }}</td>
              </tr>
            </table>
          </b-col>
        </b-row>
      </b-row>
    </div>
    <details style="text-center">
      <summary>Show Pipeline Logs</summary>
      <b-row>
        <b-col md="6">
          <b-card
            tag="article"
            class="mb-2"
            border-variant="dark"
            header="Calibrate Intensity Logs"
            header-bg-variant="dark"
            header-text-variant="light"
          >
            <b-card-text>
              <div style="text-align: left" id="calibrate_intensity_logs">
                Logs not available.
              </div>
            </b-card-text>
          </b-card>
        </b-col>
        <b-col md="6">
          <b-card
            tag="article"
            class="mb-2"
            border-variant="dark"
            header="Calculate Fluence Logs"
            header-bg-variant="dark"
            header-text-variant="light"
          >
            <b-card-text>
              <div style="text-align: left" id="calculate_fluence_logs">
                Logs not available.
              </div>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
    </details>
  </div>
</template>

<script>
export default{
  props: [
    'rerunintensitycalibration',
    'monitorJob',
    'unsaveParameters',
    'saveParameters',
    'flagParameters',
    'badParameters',
    'fluenceItems'
  ]
}
</script>



// WEBPACK FOOTER //
// src/components/calibration.vue